export const RESET: string = 'RESET';
export const GET_MOVIE: string = 'GET_MOVIE';
export const GET_MOVIE_SUCCESS: string = 'GET_MOVIE_SUCCESS';
export const GET_POPULAR_MOVIE: string = 'GET_POPULAR_MOVIE';
export const GET_POPULAR_MOVIE_SUCCESS: string = 'GET_POPULAR_MOVIE_SUCCESS';
export const GET_TOP_RATED_MOVIE: string = 'GET_TOP_RATED_MOVIE';
export const GET_TOP_RATED_MOVIE_SUCCESS: string = 'GET_TOP_RATED_MOVIE_SUCCESS';
export const GET_IMAGES: string = 'GET_IMAGES';
export const GET_IMAGES_SUCCESS: string = 'GET_IMAGES_SUCCESS';
export const GET_CREDITS: string = "GET_CREDITS";
export const GET_CREDITS_SUCCESS: string = "GET_CREDITS_SUCCESS";
export const GET_RECOMMENDATIONS: string = 'GET_RECOMMENDATIONS';
export const GET_RECOMMENDATIONS_SUCCESS: string = 'GET_RECOMMENDATIONS_SUCCESS';
export const GET_SIMILAR_MOVIES: string = 'GET_SIMILAR_MOVIES';
export const GET_SIMILAR_MOVIES_SUCCESS: string = 'GET_SIMILAR_MOVIES_SUCCESS';
export const GET_REVIEWS: string = 'GET_REVIEWS';
export const GET_REVIEWS_SUCCESS: string = 'GET_REVIEWS_SUCCESS';
export const GET_VIDEOS: string = 'GET_VIDEOS';
export const GET_VIDEOS_SUCCESS: string = 'GET_VIDEOS_SUCCESS';
export const GET_WATCH_PROVIDERS: string = 'GET_WATCH_PROVIDERS';
export const GET_WATCH_PROVIDERS_SUCCESS: string = 'GET_WATCH_PROVIDERS_SUCCESS';